export default __webpack_public_path__ + "static/media/site_banner_pt.7241c847.m4v";